<template>
  <div class="home-container" :class="{ scrolled: isScrolled }">
    <div>
      <div class="container_header home-header">
        <!-- <div class="firstHeaderTitile">
          <div class="container" :class="{ first_header: show }">
            <div
              class="d-flex justify-content-between align-items-center app_main_title"
            >
              <div class="main_title">
                {{ $t("firstHeaderTitel") }}
              </div>
              <div class="language"></div>
            </div>
          </div>
        </div> -->
        <!-- <div class="d-flex justify-content-start"> -->
        <!-- <button-language></button-language> -->
        <!-- </div> -->
        <header class="wf100 header-two" style="border-bottom: 1px solid #eee">
          <div class="h3-logo-row wf100">
            <div class="container">
              <div class="row justify-content-between m-1">
                <div class="d-flex">
                  <div class="h3-logo">
                    <router-link
                      :to="
                        $route.meta.header === 'main'
                          ? '/'
                          : `/ngo/${$route.params.id}`
                      "
                    >
                      <img
                        class="logo_ngo rounded-lg"
                        :src="
                          $route.meta.header !== 'main'
                            ? logo.logo
                            : require('@/assets/images/logo/MinistryLogo.png')
                        "
                        :alt="
                          $route.meta.header !== 'main'
                            ? `شعار منظمة ${logo.name_ar}`
                            : 'شعار وزارة الشؤون الاجتماعية و العمل'
                        "
                      />
                      <span
                        v-if="$route.meta.header !== 'main'"
                        style="max-width: 200px"
                        class="text-center mx-50 h4"
                      >
                        {{ logo.name_ar }}
                      </span>
                    </router-link>
                  </div>
                </div>
                <div class="d-flex">
                  <div class="h3-logo">
                    <router-link to="/">
                      <img
                        class="logo_ngo"
                        :src="require('@/assets/images/logo/header-logo.png')"
                        alt="شعار منصة تشارك"
                      />
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </header>
        <div
          class="fixed-height"
          v-if="$route.path.includes('/ngo/') && $route.meta.header !== 'main'"
        >
          <div class="ngo_header" :class="{ 'fixed-header': isScrolled }">
            <ngo-header></ngo-header>
          </div>
        </div>
        <div class="fixed-height" v-else>
          <div class="ngo_header" :class="{ 'fixed-header': isScrolled }">
            <main-header></main-header>
          </div>
        </div>
      </div>
      <div
        :class="{
          'fixed-header-margin': isScrolled,
        }"
        style="min-height: 63vh; background-color: #fff"
        :style="`margin-top : ${mainMargin}`"
      >
        <router-view :key="$route.path" />
      </div>

      <links-footer />
      <app-footer class="px-1" />
    </div>
  </div>
</template>

<script>
import appFooter from "./components/MainFooter.vue";
import NgoHeader from "./components/NgoHeader.vue";
import linksFooter from "./components/LinksFooter.vue";
import ButtonLanguage from "../../@core/layouts/components/app-navbar/components/ButtonLanguage.vue";
import { BButton, BDropdown, BDropdownItem } from "bootstrap-vue";
import MainHeader from "./components/MainHeader.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    appFooter,
    BButton,
    linksFooter,
    BDropdown,
    BDropdownItem,
    ButtonLanguage,
    MainHeader,
    NgoHeader,
  },
  data() {
    return {
      show: false,
      isScrolled: false,
      mainMargin: "148px",
    };
  },

  methods: {
    handlShow(reverseShow) {
      this.show = reverseShow;
    },
    setIsScrolled() {
      this.isScrolled = scrollY > 186;
    },
  },
  computed: {
    ...mapGetters("NgoHome", ["logo"]),
  },
  watch: {
    $route: {
      handler() {
        if (this.$route.meta.header !== "main") {
          this.$store.dispatch("NgoHome/getLogo", {
            id: this.$route.params.id,
          });
          this.mainMargin = "110px";
        }
      },
      immediate: true,
    },
  },

  mounted() {
    window.addEventListener("scroll", this.setIsScrolled, { passive: true });
    this.setIsScrolled();
  },

  destroyed() {
    window.removeEventListener("scroll", this.setIsScrolled, { passive: true });
  },

  created() {
    this.$store.commit("appConfig/UPDATE_SKIN", "light");

    if (this.$route.meta.header !== "main") {
      this.$store.dispatch("NgoHome/getLogo", { id: this.$route.params.id });
    }
  },
};
</script>

<style lang="scss">
@import url("./package/css/custom.scss");
@import url("./package/css/responsive.css");
@import url("./package/css/color.css");
.ngo-margin {
  margin-top: 110px;
}
.main-margin {
  margin-top: 148px;
}
.first_header {
  display: none;
}
.firstHeaderTitile {
  background-color: #f8f8f8;
}
.ngo_header {
  border-top: 1px solid #eeeeee;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.4);
}
.container_header {
  position: relative;
  top: 0px;
  z-index: 999;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.4);
}
.header-two {
  box-shadow: none;
}

.logo_ngo {
  height: 80px;
  cursor: pointer;
}

li {
  list-style-type: none;
}
@media (max-width: 576px) {
  .logo_ngo {
    height: 47px;
  }
  .language {
    display: none;
  }
  .main_title {
    font-size: 12px;
  }
  .app_main_title {
    padding-top: 3px;
    padding-bottom: 3px;
    justify-content: center !important;
  }
  .main_title {
    text-align: center;
  }
}

[dir="rtl"] {
  .nav-container {
    .dropdown-toggle::after {
      left: 0px;
      right: 0.4rem !important;
    }
  }
}

[dir="rtl"] {
  .language {
    // direction: ltr;
    margin-left: 30px;
    .dropdown-toggle::after {
      left: 0px;
      right: 6rem !important;
    }
  }
}

.nav-container {
  padding-left: 15px !important;
  padding-inline-start: 0px !important;

  button.dropdown-toggle {
    font-weight: bold;
    color: gray;
  }
  button.dropdown-toggle::after {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%234b4b4b' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-down'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E");
  }
  .active-dropdown {
    button.dropdown-toggle {
      background-color: var(--primary);
      color: white;
      transition: all 0.2s ease;
      &:hover {
        background-color: var(--primary);
        opacity: 0.8;
        color: white;
      }
    }
    button.dropdown-toggle::after {
      background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23fff' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-down'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E");
    }
  }
  .dropdown-menu {
    width: fit-content;
  }
  .header-nav {
    font-weight: bold;
    color: gray;
    padding: 3px 10px;
    transition: all 0.2s ease;
    border-radius: 5px;
    &:hover {
      background-color: rgba(14, 87, 150, 0.12);
    }
  }
  display: flex;
  align-items: center;
  gap: 10px;
  .router-link-exact-active {
    background-color: var(--primary) !important;
    color: white !important;
  }
}
.header-button {
  margin: 0px 10px;
  display: flex;
  gap: 3px;
  align-items: center;
  span {
    margin: 0px 2px;
  }
}

.exact-active {
  color: #000;
}
</style>
